module.exports = __webpack_public_path__ + "img/square-download.95f25975.svg";